import styled from 'styled-components';

export const TopRightContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xl};
  background-color: ${({ theme }) => theme.colors.grey5};
  padding-top: ${({ theme }) => theme.spacing.s};
  padding-left: ${({ theme }) => theme.spacing.m};
  padding-right: ${({ theme }) => theme.spacing.m};
  @media screen and (width <= 768px) {
    display: none;
    /* overflow-x: scroll; */
  }
`;

export const CourseContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.m};
  height: 100%;
  /* border: 2px solid red; */
  h2 {
    margin-bottom: ${({ theme }) => theme.spacing.s};
  }
  @media screen and (max-width: 768px) {
    min-height: 100%;
    overflow-y: visible;
    padding: 1rem;
  }
`;
